import { Tabs } from "@chakra-ui/react";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import CommonLayout from "../CommonLayout";

import ActiveSubscriptionsTable from "./components/ActiveSubscriptionsTable";
import Buttons from "./components/Buttons";
import GuestsTable from "./components/GuestsTable";
import SubscriptionMetricsCards from "./components/MetricsCards";

const SubscriptionContainer = (): JSX.Element => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") ?? "suscriptores";
  const handleTabChange = (value: string) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set("tab", value);
        return next;
      },
      { replace: true }
    );
  };

  useEffect(() => {
    if (!searchParams.get("tab")) {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set("tab", "suscriptores");
          return next;
        },
        { replace: true }
      );
    }
  }, [searchParams, setSearchParams]);

  const children = <SubscriptionMetricsCards />;
  const buttons = <Buttons />;
  const tabContentProps = {
    display: "flex",
    flexDirection: "column" as const,
    flex: "1",
    minH: 0,
    css: { "&[hidden]": { display: "none" } },
  };
  const table = (
    <Tabs.Root
      value={activeTab}
      onValueChange={(e) => handleTabChange(e.value)}
      variant="line"
      colorPalette="palomma"
      display="flex"
      flexDirection="column"
      flex="1"
      minH={0}
    >
      <Tabs.List bg="transparent" mb={4} flexShrink={0}>
        <Tabs.Trigger
          value="suscriptores"
          data-tour="subscriptions-tab-suscriptores"
          fontWeight="medium"
          pb={3}
        >
          Suscriptores
        </Tabs.Trigger>
        <Tabs.Trigger
          value="invitados"
          data-tour="subscriptions-tab-invitados"
          fontWeight="medium"
          pb={3}
        >
          Invitados
        </Tabs.Trigger>
      </Tabs.List>
      <Tabs.Content value="suscriptores" {...tabContentProps}>
        <ActiveSubscriptionsTable />
      </Tabs.Content>
      <Tabs.Content value="invitados" {...tabContentProps}>
        <GuestsTable />
      </Tabs.Content>
    </Tabs.Root>
  );

  return (
    <CommonLayout
      title="Suscripciones"
      subtitle="Consulta las suscripciones de tus inquilinos e invita a propietarios y colaboradores"
      buttons={buttons}
      children={children}
      table={table}
    />
  );
};

export default SubscriptionContainer;
